import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './CustomerFeedback.css';

// --- Data for the testimonials (no changes here) ---
const testimonials = [
  { rating: 4.5, stars: '★★★★☆', text: "As a digital marketing agency our team works day in and day out on websites of all kinds. Some of the most common errors we see are websites not optimized for SEO because of old, boring, or out of date themes or designs.", name: 'Stefhen Hoking', title: 'HR OF', company: 'Desgin360', companyClass: 'company-name', avatar: null },
  { rating: 4.7, stars: '★★★★☆', text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters.", name: 'Abdullah Al Mamun', title: 'Designer OF', company: 'DesginCode', companyClass: 'company-name', avatar: 'https://i.imgur.com/Q23agv1.png' },
  { rating: 4.9, stars: '★★★★☆', text: "Build the perfect online store using our high-converting website template. Totam ipsam autem itaque exercitationem adipisci perspiciatis veritatis doloremque non impedit rem minima, iste veniam porro modi!", name: 'Mohammad Rashed Khan', title: 'CEO OF', company: 'DesginLab', companyClass: 'company-name', avatar: 'https://i.imgur.com/Q23agv1.png' },
  { rating: 4.8, stars: '★★★★☆', text: "The level of detail and the user-friendly design exceeded our expectations. Our customer engagement has increased significantly since we launched the new site. Highly recommended for any business looking to grow.", name: 'Jessica Miller', title: 'Marketing Head OF', company: 'Creative Inc', companyClass: 'company-name', avatar: 'https://i.imgur.com/r62z5k1.png' }
];

const CustomerFeedback = () => {
  return (
    <section className="feedback-section-new">
      <h2 className="feedback-section-title">Customers Feedback</h2>
      <Swiper
        modules={[Navigation]}
        navigation={{
          nextEl: '.feedback-arrow-next',
          prevEl: '.feedback-arrow-prev',
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 25 }, // Increased space
          1200: { slidesPerView: 3, spaceBetween: 30 }, // Adjusted breakpoint
        }}
        className="feedback-swiper"
      >
        {testimonials.map((testimonial, index) => (
          <SwiperSlide key={index}>
            <div className="testimonial-card-new">
              <div className="rating-new">
                <span className="star-icons">{testimonial.stars}</span>
                <span>({testimonial.rating.toFixed(1)})</span>
              </div>
              <p className="feedback-text-new">{testimonial.text}</p>
              <div className="customer-info-new">
                {testimonial.avatar && (
                  <img src={testimonial.avatar} alt={testimonial.name} className="customer-avatar-new" />
                )}
                {!testimonial.avatar && <div className="avatar-placeholder"></div>}
                <div className="customer-details-new">
                  <p className="customer-name-new">{testimonial.name}</p>
                  <p className="customer-title-new">
                    {testimonial.title}{' '}
                    <span className={testimonial.companyClass}>{testimonial.company}</span>
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      
      {/* --- NAVIGATION WITH SVG ICONS --- */}
      <div className="feedback-navigation">
        <div className="feedback-arrow feedback-arrow-prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </div>
        <div className="feedback-arrow feedback-arrow-next">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
      </div>
    </section>
  );
};

export default CustomerFeedback;